import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import type { InvitePreview } from "../types";

export function invitePreviewKey(token: string) {
  return ["invite-preview", token] as const;
}

// No auth required — anyone with the link can preview an invite.
export function useInvitePreview(token: string): UseQueryResult<InvitePreview, ApiError> {
  return useQuery<InvitePreview, ApiError>({
    queryKey: invitePreviewKey(token),
    queryFn: ({ signal }) => apiFetch<InvitePreview>(`/api/invites/${token}`, { signal }),
    enabled: !!token,
    retry: false,
  });
}
